import accountsTreePage from '../components/features/accounts/AccountsTreePage'
import accountingJournalPage from '../components/features/journals/AccountingJournalPage'
import accountCreateEdit from '../components/features/accounts/sub-components/AccountCreateEdit.vue'
import accountInfoCard from '../components/features/accounts/sub-components/AccountInfoCard.vue'
import cashJournalPage from '../components/features/journals/CashJournalPage'
import materialJournalPage from '../components/features/journals/MaterialsJournalPage.vue'
import manufacturingBond from '../components/features/manufacturing/manufacturingBond.vue'
import manufacturingCreateEdit from '../components/features/manufacturing/sub-components/manufacturingCreateEdit.vue'
import customStatementsPage from '../components/features/settings/CustomStatementsPage.vue'
import currenciesPage from '../components/features/settings/CurrenciesPage.vue'
import financialFilesPage from '../components/features/system-management/FinancialFilesPage'
import defaultAccounts from '../components/features/settings/DefaultAccountsPage.vue'
import accountStatementPage from '../components/features/statements/AccountStatementPage'
import materialStatmentPage from '../components/features/statements/MaterialStatmentPage.vue'
import SalesStatement from '../components/features/statements/SalesStatement.vue'
import matchings from '../components/features/statements/sub-components/Matchings.vue'
import tester from '../components/test/tester.vue'
import usersPage from '../components/features/system-management/UsersPage.vue'
import accountCustomStatementPage from '../components/features/statements/AccountCustomStatementPage'
import journalTablePage from '../components/features/journals/JournalTablePage'
import journalsPage from '../components/features/journals/JournalsPage'
import trailBalance from '../components/features/trail-balance/TrailBalancePage'
import finalAccountsPage from '../components/features/final-accounts/FinalAccountsPage.vue'
import publicSettingsPage from '../components/features/settings/publicSettingsPage.vue'
import login from '../components/features/Login.vue'
import QuickFinancialFileSelector from '../components/features/QuickFinancialFileSelector.vue'
import Statistics from '../components/features/statistics/Statistics.vue'
import home from '../components/features/Home.vue'
import splashWindow from '../components/features/SplashWindow.vue'
import invoiceSale from '../components/features/Invoices/InvoiceSalePage.vue'
import invoiceBuy from '../components/features/Invoices/InvoiceBuyPage.vue'
import materialsTree from '../components/features/warehouse-materials/MaterialsTreePage.vue'
import materialCreateEdit from '../components/features/warehouse-materials/sub-components/MaterialCreateEdit.vue'
import warehouseInventory from '../components/features/warehouse-materials/WarehouseInventoryPage.vue'
import unitSizes from '../components/features/settings/UnitSizesPage.vue'
import InvoicesTypes from '../components/features/invoices-types/InvoicesTypes.vue'
import warehouses from '../components/features/settings/WarehousesPage.vue'
import SaleInvoiceRefund from '../components/features/Invoices/SaleInvoiceRefund.vue'
import BuyInvoiceRefund from '../components/features/Invoices/BuyInvoiceRefund.vue'
import AccountsSummary from '../components/features/statistics/AccountsSummary.vue'
import EarningsAndLossChart from '../components/features/statistics/EarningsAndLossChart.vue'
import TransferDocument from '../components/features/journals/TransferDocument'
import Invoices from '../components/features/Invoices/Invoices'
// import ReceiptBound from '../components/features/journals/ReceiptBound'
// import PaymentBound from '../components/features/journals/PaymentBound'
// import RegionInWarehouse from '../components/features/settings/RegionInWarehouse'
// import microPermission from '../components/features/settings/microPermission'
import AdvanceStatement from '../components/features/statements/AdvanceStatement.vue'

import AuditLog from '../components/features/system-management/AuditLog.vue'

export default [
    {
        name: "home",
        langName:{
            ar: 'الرئيسية',
            en: 'Home',
            es: 'Incial',
        },
        path: "/",
        component: home,
    },
    {
		name: 'login',
        langName:{
            ar: 'تسجيل الدخول',
            en: 'Login',
            es: 'Inciar sessión',
        },
		path: '/login',
		component: login,
	},
    {
		name: 'statistics',
        langName:{
            ar: 'الإحصائيات',
            en: 'statistics',
            es: 'Estadísticas',
        },
		path: '/statistics',
		component: Statistics,
        children: [
            {
                name: 'statistics-final-accounts',
                langName:{
                    ar: 'الحسابات الختامية',
                    en: 'Final accounts',
                    es: 'Cuentas finales',
                },
                path: "final-accounts",
                component: finalAccountsPage,
            },
            {
                name: 'statistics-custom-statements',
                langName:{
                    ar: 'كشوف مُخصصة',
                    en: 'Customised Statements',
                    es: 'Estados personalizados',
                },
                path: "custom-statements",
                component: accountCustomStatementPage,
            },
            {
                name: 'statistics-account-summary',
                langName:{
                    ar: 'ملخص حسابات',
                    en: 'Account summary',
                    es: '',
                },
                path: "/account-summary",
                component: AccountsSummary,
            },
            {
                name: 'statistics-earnings-and-loss-chart',
                langName:{
                    ar: 'مخطط أرباح و خسائر',
                    en: 'Earnings and loss chart',
                    es: '',
                },
                path: "earnings-and-loss-chart",
                component: EarningsAndLossChart,
            }
        ]
	},
    {
		name: 'quick-financial-file-selector',
        langName:{
            ar: 'اختر الملف المالي',
            en: 'Select financial file',
            es: 'Seleccionar archivo financiero',
        },
		path: '/quick-financial-file-selector',
		component: QuickFinancialFileSelector,
	},
    {
        name: "financial-files",
        langName:{
            ar: 'الملفات المالية',
            en: 'Financial Files',
            es: 'Archivos financieros',
        },
        component: financialFilesPage,
        path: "/financial-files",
    },
    {
        name: "users",
        langName:{
            ar: "المستخدمين",
            en: "Users",
            es: "Usuarios",
        },
        component: usersPage,
        path: "/users"
    },
    {
        name: "default-accounts",
        langName:{
            ar: "الحسابات الافتراضية",
            en: "Default Accounts",
            es: "Cuentas predeterminadas",
        },
        component: defaultAccounts,
        path: "/default-accounts"
    },
    {
        name: 'custom-statements',
        langName:{
            ar: 'كشوف مُخصصة',
            en: 'Customised Statements',
            es: 'Estados personalizados',
        },
        path: "/custom-statements",
        component: customStatementsPage,
    },
    {
        name: 'trail-balance',
        langName:{
            ar: 'ميزان المراجعة',
            en: 'Trial Balance',
            es: 'Balance de prueba',
        },
        path: "/trail-balance",
        component: trailBalance,
    },
    {
        name: 'final-accounts',
        langName:{
            ar: 'الحسابات الختامية',
            en: 'Final accounts',
            es: 'Cuentas finales',
        },
        path: "/final-accounts",
        component: finalAccountsPage,
    },
    {
        name: "accounts-tree",
        langName:{
            ar: "شجرة الحسابات",
            en: "Accounts Tree",
            es: "Árbol de cuentas",
        },
        component: accountsTreePage,
        path: "/accounts-tree",
        children: [
            {
                name: 'account',
                langName:{
                    ar: "شجرة الحسابات",
                    en: "Accounts Tree",
                    es: "Árbol de cuentas",
                },
                path: ":id/account",
                component: accountInfoCard,
                props: true
            },
            {
                name: 'add-account',
                langName:{
                    ar: "إنشاء حساب",
                    en: "Create an account",
                    es: "Crear una cuenta",
                },
                path: ":parentId/create-account",
                component: accountCreateEdit,
                props: true 
            },
            {
                name: 'create-account',
                langName:{
                    ar: "إنشاء حساب",
                    en: "Create an account",
                    es: "Crear una cuenta",
                },
                path: "create-account",
                component: accountCreateEdit,
                props: false 
            },
            {
                name: 'edit-account',
                langName:{
                    ar: "تعديل حساب",
                    en: "Edit Account",
                    es: "Editar cuenta",
                },
                path: ":id/edit-account",
                component: accountCreateEdit,
                props: true
            },
        ]
    },
    {
        name: "account-statement",
        langName:{
            ar: "كشف حساب",
            en: "Account Statement",
            es: "Estado de cuenta",
        },
        component: accountStatementPage,
        path: "/account-statement",
        props: false,
        children: [
            {
                name: 'statement',
                langName:{
                    ar: "كشف حساب",
                    en: "Account Statement",
                    es: "Estado de cuenta",
                },
                path: ":id/statement",
                component: accountStatementPage,
                props: true,
            }, 
            {
                name: 'matchings',
                langName:{
                    ar: "جدول المُطابقات",
                    en: "Matchings",
                    es: "Estado de reconciliación",
                },
                path: ":id/matchings",
                component: matchings,
                props: true
            },]
    },
    {
        name: "account-custom-statement",
        langName:{
            ar: "كشف حساب مُخصص",
            en: "Customised Account Statement",
            es: "Estado de cuenta personalizado",
        },
        component: accountCustomStatementPage,
        path: "/account-custom-statement",
        props: false,
    },
    {
        name: "material-statment",
        langName:{
            ar: "كشف مادة",
            en: "Item Statement",
            es: "Estado de artículo",
        },
        component: materialStatmentPage,
        path: "/material-statment/:id",
        props: true,
    },
    {
        name: 'sales-statement',
        langName:{
            ar: 'كشف مبيعات',
            en: 'Sales statement',
            es: 'Declaración de venta',
        },
        component: SalesStatement,
        path: '/sales-statement',
    },
    {
        name: "materials-statment",
        langName:{
            ar: "كشف مادة",
            en: "Item Statement",
            es: "Estado de artículo",
        },
        component: materialStatmentPage,
        path: "/material-statment",
        props: false,
    },
    {
        name: "custom-statement",
        langName:{
            ar: "كشف حساب مُخصص",
            en: "Customised Account Statement",
            es: "Estado de cuenta personalizado",
        },
        component: accountCustomStatementPage,
        path: "/account-custom-statement/:id/account",
        props: true
    },
    {
        name: "advance-statement",
        langName: {
            ar: "كشف أستاذ",
            en: "Advance statement",
            es: "Declaración anticipada"
        },
        component: AdvanceStatement,
        path: '/advance-statement',
        props: true
        
    },
    {
        name: "accounting-journal",
        langName:{
            ar: 'اليومية المحاسبية',
            en: 'Accounting Journal',
            es: 'Diario contable',
        },
        component: accountingJournalPage,
        path: "/accounting-journal/:id?",
        props: true,
    },
    {
        name: "journals",
        langName:{
            ar: 'اليوميات',
            en: 'Journals',
            es: 'Diarios',
        },
        component: journalsPage,
        path: "/journals",
        props: false,
    },
    {
        name: "cash-journal",
        langName:{
            ar: 'اليومية النقدية',
            en: 'Cash journal',
            es: 'Diario de caja',
        },
        component: cashJournalPage,
        path: "/cash-journal/:id",
        props: true
    },
    {
        name: "cash-journals",
        langName:{
            ar: 'اليومية النقدية',
            en: 'Cash Journal',
            es: 'Diario de caja',
        },
        component: cashJournalPage,
        path: "/cash-journal",
        props: false
    },
    {
        name: "materials-journals",
        langName:{
            ar: 'يومية المواد',
            en: 'Items Journals',
            es: 'Diario de artículos',
        },
        component: materialJournalPage,
        path: "/materials-journal",
        props: false
    },
    {
        name: "materials-journal",
        langName:{
            ar: 'يومية المواد',
            en: 'Items Journals',
            es: 'Diario de artículos',
        },
        component: materialJournalPage,
        path: "/materials-journal/:id",
        props: true
    },
    {
        name: "manufacturing-bond",
        langName:{
            ar: 'سند التصنيع',
            en: 'Manufacturing Bond',
            es: 'Bono de fabricación',
        },
        component: manufacturingBond,
        path: "/manufacturing-bond",
        props: false,
    },
    {
        name: "create-product",
        langName:{
            ar: "إنشاء المنتج",
            en: "Create Product",
            es: "Crear producto",
        },
        component: manufacturingCreateEdit,
        path: "/create-product",
        props: false
    },
    {
        name: "edit-product",
        langName:{
            ar: "تعديل المنتج",
            en: "Edit Product",
            es: "Editar producto",
        },
        component: manufacturingCreateEdit,
        path: "/edit-product",
        props: false
    },
    {
        name: "show-product",
        langName:{
            ar: "عرض التفاصيل",
            en: "Show Details",
            es: "Mostrar detalles",
        },
        component: manufacturingCreateEdit,
        path: "/show-product",
        props: false
    },
    {
        name: "journal-table",
        langName:{
            ar: 'جدول اليومية',
            en: 'Journal',
            es: 'Horario diario',
        },
        component: journalTablePage,
        path: "/journal-table",
        props: false
    },
    {
        name: "tester",
        component: tester,
        path: "/tester",
        props: true
    },
    {
        name: "currencies",
        langName:{
            ar: "العملات",
            en: "Currencies",
            es: "Monedas",
        },
        component: currenciesPage,
        path: "/currencies",
        props: true
    },
    {
        name: "settings",
        langName:{
            ar: "الإعدادات العامة",
            en: "Settings",
            es: "Ajustes generales",
        },
        component: publicSettingsPage,
        path: "/public-settings",
        props: false
    },
    {
        name: "splash-window",
        langName:{
            ar: "واجهة البداية",
            en: "Loading Page",
            es: "Página de inicio",
        },
        component: splashWindow,
        path: "/splash-window",
        props: false
    },
    {
        name: "invoices-sale",
        langName:{
            ar: "فاتورة بيع",
            en: "Sale Invoice",
            es: "Factura de venta",
        },
        component: invoiceSale,
        path: "/invoices-sale/:id?",
        props: true
    },
    {
        name: "invoices-buy",
        langName:{
            ar: "فاتورة شراء",
            en: "Purchase Invoice",
            es: "Factura de compra",
        },
        component: invoiceBuy,
        path: "/invoices-buy/:id?",
        props: true
    },
    {
        name: "sale-invoice-refund",
        langName: {
            ar: "فاتورة مرتجع بيع ",
            en: "Sales invoice refund",
            es: "Factura de venta devuelta"
        },
        component: SaleInvoiceRefund,
        path: "/sale-invoice-refund/:id?"
    },
    {
        name: "buy-invoice-refund",
        langName: {
            ar: "فاتورة مرتجع شراء",
            en: "Buy invoice refund",
            es: "Comprar reembolso de factura",
        },
        component: BuyInvoiceRefund,
        path: "/buy-invoice-refund/:id?"
    },
    {
        name: "materials-tree",
        langName:{
            ar: "شجرة المواد",
            en: "Items Tree",
            es: "Árbol de artículos",
        },
        component: materialsTree,
        path: "/materials-tree/:warehouseId",
        children: [
            {
                name: "create-material",
                langName:{
                    ar: "إنشاء مادة",
                    en: "Create Item",
                    es: "Crear artículo",
                },
                component: materialCreateEdit,
                path: "create-material",
                props: false
            },
            {
                name: "add-material",
                langName:{
                    ar: "إنشاء مادة",
                    en: "Create Item",
                    es: "Crear artículo",
                },
                component: materialCreateEdit,
                path: "create-material/:parentId",
                props: true
            },
            {
                name: "update-material",
                langName:{
                    ar: "تعديل مادة",
                    en: "Update Item",
                    es: "Actualizar artículo",
                },
                component: materialCreateEdit,
                path: "update-material/:id",
                props: false
            },
        ]
    },
    {
        name: "warehouses-inventory",
        langName:{
            ar: "جرد المواد",
            en: "Items Inventory",
            es: "Inventario de artículos",
        },
        component: warehouseInventory,
        path: "/warehouse-inventory",
        props: false
    },
    {
        name: "warehouse-inventory",
        langName:{
            ar: "جرد المواد",
            en: "Items Inventory",
            es: "Inventario de artículos",
        },
        component: warehouseInventory,
        path: "/warehouse-inventory/:warehouseId",
        props: false
    },
    {
        name: "warehouses",
        langName:{
            ar: "المستودعات",
            en: "Warehouses",
            es: "Almacenes",
        },
        component: warehouses,
        path: "/warehouses",
        props: false
    },
    {
        name: "unit-sizes",
        langName:{
            ar: "وحدات القياس",
            en: "Units",
            es: "Unidades",
        },
        component: unitSizes,
        path: "/unit-sizes",
        props: false
    },
    {
        name: 'invoices-types',
        path: '/invoices-types',
        component: InvoicesTypes,
        langName:{
            ar: 'أنواع الفواتير',
            en: 'Invoices types',
            es: 'Tipos de facturas',
        },
    },
    {
        name: 'transfer-document',
        path: '/transfer-document',
        component: TransferDocument,
        langName:{
            ar: 'سند مناقلة بين مستودعين',
            en: 'transfer document',
            es: '',
        },
    },
    {
        name: 'invoices',
        path: '/invoices',
        component: Invoices,
        langName:{
            ar: 'الفواتير',
            en: 'Invoices',
            es: '',
        },
    },
    /* {
        name: 'receipt-bound',
        path: '/receipt-bound',
        component: ReceiptBound,
        langName:{
            ar: 'سند القبض',
            en: 'Receipt bound',
            es: '',
        },
        
    },
    {

        name: 'payment-bound',
        path: '/payment-bound',
        component: PaymentBound,
        langName:{
            ar: 'سند الدفع',
            en: 'Payment bound',
            es: '',
        },
        
    },
    {

        name: 'region-in-warehouse',
        path: '/region-in-warehouse',
        component: RegionInWarehouse,
        langName:{
            ar: 'المناطق ضمن المستودع',
            en: 'Region in warehouse',
            es: '',
        },
        
    },
    {
        name: 'micro-permission',
        path:'/permissions',
        component: microPermission,
        langName: {
            ar: 'الصلاحيات',
            en: 'Permission',
            es: ''
        }
    } */

    {
        name: "audit-log",
        langName:{
            ar: "سجل التدقيق",
            en: "Audit Log",
            es: "registro de auditoría",
        },
        component: AuditLog,
        path: "/audit-log"
    },
]

